<template>
  <div class="code-box" @click.stop>
    <div class="title">
      分享方式
    </div>
    <div class="share-mode">
      <div class="flex">
        <div class="share-box-flex" @click="$emit('weChatCollage')">
          <div class="img">
            <img
              class="img-100"
              src="https://img2.coocaa.com/ui/partner-mini-program/weixin.png"
            />
          </div>
          <div class="text">微信好友</div>
        </div>
      </div>
      <div class="flex">
        <div class="share-box-flex" @click="$emit('shareCollage')">
          <div class="img">
            <img
              class="img-100"
              src="https://img2.coocaa.com/ui/partner-mini-program/pie.png"
            />
          </div>
          <div class="text">生成海报</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.title {
  line-height: 40px;
  height: 40px;
  padding: 0 15px;
  font-size: 13px;
  text-align: left
}

.share-mode {
  display: flex;
  justify-content: space-around;

  .flex {
    padding: 15px 0;
    text-align: center;

    .share-box-flex {

    }


    .img {
      width: 50px;
      height: 50px;
    }

    .text {
      line-height: 30px;
      height: 30px;
      font-size: 12px;
      color: #666;
    }
  }
}
</style>